<template>
  <v-card class="pa-6" elevation="0">
    <v-row>
      <v-col cols="12" sm="4">
        <AutocompleteClass
          v-model="selectedClass"
          label="Lớp học"
          placeholder="Nhập tên lớp học"
          @change="onClassChange"
          outlined
          dense
          hide-details="auto"
          class="mb-4"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          v-model="selectedEvaluationType"
          :items="evaluationTypes"
          label="Loại đánh giá"
          outlined
          dense
          hide-details="auto"
          class="mb-4"
          @change="onEvaluationTypeChange"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="searchQuery"
          label="Tên đánh giá"
          placeholder="Nhập từ khóa"
          outlined
          dense
          hide-details="auto"
          append-icon="mdi-magnify"
          @click:append="onSearch"
          @keyup.enter="onSearch"
          class="mb-4"
        />
      </v-col>
    </v-row>
    <div class="d-flex justify-end">
      <v-btn color="primary" @click="onSearch" :disabled="!isSearchEnabled" :loading="loading" elevation="0" outlined>
        <v-icon left>mdi-magnify</v-icon>
        Tìm kiếm
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass.vue'

export default {
  components: {
    AutocompleteClass,
  },
  data() {
    return {
      selectedClass: null,
      selectedEvaluationType: '',
      searchQuery: '',
      evaluationTypes: [
        { text: 'Buổi học', value: 'session' },
        { text: 'Tuần', value: 'week' },
        { text: 'Tháng', value: 'month' },
        { text: 'Tùy chỉnh', value: 'custom' },
      ],
    }
  },
  computed: {
    ...mapState('evaluate', ['loading', 'error']),
    isSearchEnabled() {
      return this.selectedClass || this.selectedEvaluationType || this.searchQuery.trim().length > 0
    },
  },
  methods: {
    ...mapActions('evaluate', ['fetchEvaluates']),
    onClassChange(selectedClass) {
      this.selectedClass = selectedClass
    },
    onEvaluationTypeChange(selectedType) {
      this.selectedEvaluationType = selectedType
    },
    async onSearch() {
      try {
        const params = {
          class: this.selectedClass ? this.selectedClass.id : undefined,
          type: this.selectedEvaluationType,
          title_contains: this.searchQuery,
        }
        this.$emit('search', params)
      } catch (error) {
        console.error('Error fetching evaluates:', error)
      }
    },
  },
}
</script>
